import moment from 'moment';
import { ValidationResult } from '../types/candidate.types';
import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js';


export const validateName = (name: string): ValidationResult => {
  if (!name || name.trim() === '') {
    return { isValid: false, errorMessage: 'This field is required' };
  }
  
  if (name.trim().length === 0) {
    return { isValid: false, errorMessage: 'Name cannot contain only spaces' };
  }
  
  const nameRegex = /^[a-zA-Z\s'-]+$/;
  if (!nameRegex.test(name.trim())) {
    return { isValid: false, errorMessage: 'Name can only contain letters, spaces, hyphens, and apostrophes' };
  }
  
  if (name.trim().length > 50) {
    return { isValid: false, errorMessage: 'Maximum length is 50 characters' };
  }
  
  if (name !== name.trim()) {
    return { isValid: false, errorMessage: 'Name cannot start or end with spaces' };
  }
  
  return { isValid: true, errorMessage: '' };
};

export const validateNIC = (nic: string): boolean => {
  if (!nic) return true;

  if (nic.length === 10) {
    const first9 = nic.substring(0, 9);
    const last = nic.substring(9, 10).toUpperCase();
    return /^\d{9}$/.test(first9) && last === 'V';
  } 
  else if (nic.length === 12) {
    return /^\d{12}$/.test(nic);
  }
  
  return false;
};

export const validateEmail = (email: string): boolean => {
  if (!email) return true;
  return email.includes('@') && email.endsWith('.com');
};



export const validateDate = (date: string): boolean => {
  if (!date) return false;
  return moment(date, 'YYYY-MM-DD', true).isValid();
};


export const validateMobileNumberRequired = (number: string): ValidationResult => {
  if (!number || number.trim() === '') {
    return { isValid: false, errorMessage: 'Mobile Number is required' };
  }
  
  const cleanNumber = number.replace(/\D/g, '');
  if (cleanNumber.length < 10 || cleanNumber.length > 15) {
    return { isValid: false, errorMessage: 'Please enter a valid mobile number (10-15 digits)' };
  }
  
  return { isValid: true, errorMessage: '' };
};









export const validateMobileNumber = (number: string): ValidationResult => {
  if (!number || number.trim() === '') {
    return { isValid: false, errorMessage: 'Mobile number is required' };
  }
  
  try {
    // Use libphonenumber to validate
    const phoneNumber = parsePhoneNumberFromString(number);
    
    if (!phoneNumber) {
      return { isValid: false, errorMessage: 'Invalid phone number format' };
    }
    
    if (!phoneNumber.isValid()) {
      return { isValid: false, errorMessage: `This doesn't appear to be a valid phone number` };
    }
    
    return { isValid: true, errorMessage: '' };
  } catch (error) {
    return { isValid: false, errorMessage: 'Invalid phone number format' };
  }
};

// Replace the existing function or add this as an alternative
export const validatePhoneNumberWithCountry = (phoneNumber: string, country?: string): ValidationResult => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return { isValid: false, errorMessage: 'Mobile number is required' };
  }
  
  try {
    // If we can determine the country, we can do a more specific validation
    if (country) {
      if (!isValidPhoneNumber(phoneNumber, country as any)) {
        return { 
          isValid: false, 
          errorMessage: `This doesn't appear to be a valid ${country.toUpperCase()} phone number` 
        };
      }
    } else {
      const parsedNumber = parsePhoneNumberFromString(phoneNumber);
      if (!parsedNumber || !parsedNumber.isValid()) {
        return { isValid: false, errorMessage: 'Invalid phone number format' };
      }
    }
    
    return { isValid: true, errorMessage: '' };
  } catch (error) {
    return { isValid: false, errorMessage: 'Invalid phone number format' };
  }
};